import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 text-muted" }, "数字越小越靠前", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.cardRarity,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "稀有度名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.cardRarity.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardRarity.name) = $event)),
              placeholder: "请输入稀有度名称（如 R、SR、SSR）",
              maxlength: "20",
              "show-word-limit": "",
              style: {"width":"300px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sort"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.cardRarity.sort,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardRarity.sort) = $event)),
              min: 0,
              max: 9999
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}